import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import selectAdvisoryReportParametersDialog from '../dialog.selectAdvisoryReportParameters';
import controller from './select-advisory-report-types-dialog.controller';
import template from './select-advisory-report-types-dialog.html';

class dialogService {
  getOptions($event, { hasAdvisoryServices, reportPackage }) {
    return {
      controller,
      controllerAs: 'selectAdvisoryReportTypesDialogVM',
      locals: {
        hasAdvisoryServices,
        reportPackage,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.selectAdvisoryReportTypesDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
    selectAdvisoryReportParametersDialog
  ])
  .service('selectAdvisoryReportTypesDialog', dialogService).name;
